import { Button, Flex, Tooltip, Typography } from "antd";
import { LeftCircleOutlined } from "@ant-design/icons";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { Link } from "react-router-dom";
import { goBack } from "../../models/navSlice";

type TitleWithNavBackProps = {
  title: string;
  titleLevel?: 5 | 1 | 2 | 3 | 4 | undefined;
  marginTop?: string;
};

const TitleWithNavBack: FC<TitleWithNavBackProps> = ({
  title,
  titleLevel = 3,
  marginTop = "0px",
}) => {
  const { Title } = Typography;
  const navState = useSelector((state: RootState) => state.nav);
  const dispatch = useDispatch<AppDispatch>();

  return (
    <Flex
      style={{ marginBottom: "2em", marginTop: marginTop }}
      align="center"
      gap={6}
    >
      {navState.navHistory.length > 0 && (
        <Tooltip title="Previous page">
          <Link
            onClick={() => dispatch(goBack())}
            to={navState.navHistory[navState.navHistory.length - 1]}
          >
            <Button shape="circle" icon={<LeftCircleOutlined />} />
          </Link>
        </Tooltip>
      )}
      <div style={{ width: "100%", textAlign: "center" }}>
        <Title style={{ margin: 0, color: title === "PATIENT REGISTRATION" ? "rgb(65, 50, 50)" : "black", fontSize: title === "PATIENT REGISTRATION" ? "18px" : "28px"  }} level={titleLevel}>
          {title}
        </Title>
      </div>
    </Flex>
  );
};

export default TitleWithNavBack;
